import React from 'react';
 
const NoPageFound= () => {
    return (
       <div>
          <p>Error: Page does not exist!</p>
       </div>
    );
}
 
export default NoPageFound;